/* SHOEKIDS — contact form helpers */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  /* ---------- Contact: topic cards + wholesale field ---------- */
  const topicSelect = $('[data-topic-select]');
  if (topicSelect) {
    const wholesale = $('[data-wholesale-only]');
    const sync = () => {
      const v = (topicSelect.value || '').toLowerCase();
      if (wholesale) wholesale.hidden = !v.includes('wholesale');
      $$('[data-topic]').forEach((b) => b.classList.toggle('is-active', b.dataset.topic === topicSelect.value));
    };
    const pick = (name) => {
      const opt = Array.from(topicSelect.options).find((o) => o.value.toLowerCase() === name.toLowerCase() || o.value.toLowerCase().includes(name.toLowerCase()));
      if (opt) { topicSelect.value = opt.value; sync(); }
    };
    $$('[data-topic]').forEach((b) => b.addEventListener('click', () => {
      pick(b.dataset.topic);
      document.getElementById('contact-form').scrollIntoView({ behavior: 'smooth' });
      setTimeout(() => { const f = $('#cf-name'); f && f.focus({ preventScroll: true }); }, 600);
    }));
    topicSelect.addEventListener('change', sync);
    const q = new URLSearchParams(window.location.search).get('topic');
    if (q) pick(q);
    if (document.querySelector('.form-success, .form-errors')) document.getElementById('contact-form').scrollIntoView();
  }
})();
